export enum AccessType {
  Enabled = 'enabled',
  Disabled = 'disabled',
  Expiring = 'expiring',
  Trial = 'trial',
}

export class Access {
  constructor(
    public readonly type: AccessType,
  ) {
  }
}
